import React, { memo } from "react";
import PropTypes from "prop-types";
import { Box, Image, Icon, Flex } from "@chakra-ui/react";
import { BiPlayCircle, BiLandscape } from "react-icons/bi";

const wrapperStyles = {
  position: "relative",
  width: "full",
  height: "full",
  borderRadius: "lg",
  overflow: "hidden",
};

const imageStyles = {
  width: "full",
  height: "full",
  objectFit: "cover",
  border: 0,
};

const fallbackStyles = {
  width: "full",
  height: "full",
};

const countStyles = {
  position: "absolute",
  top: "auto",
  left: "auto",
  bottom: "0",
  right: "0",
  display: "inline-block",
  width: "auto",
  height: "auto",
  padding: "1",
  backgroundColor: "blackAlpha.800",
  color: "white",
  fontSize: "xs",
  lineHeight: "1",
  borderTopLeftRadius: "sm",
  borderBottomRightRadius: "sm",
};

const videoIconStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  bottom: "auto",
  right: "auto",
  width: "auto",
  height: "auto",
  transform: "translateX(-50%) translateY(-50%)",
  fontSize: "2xl",
  color: "blackAlpha.800",
};

const SimplePostCover = ({ src, count, isVideo, isPast }) => {
  if (!src) {
    return null;
  }

  const renderFallback = () => (
    <Flex alignItems="center" justifyContent="center" sx={fallbackStyles}>
      {isVideo ? null : <Icon as={BiLandscape} />}
    </Flex>
  );

  return (
    <Box sx={wrapperStyles}>
      <Image
        src={src}
        fallback={renderFallback()}
        sx={imageStyles}
        opacity={isPast ? "0.5" : "1"}
      />
      {count > 1 ? <Box sx={countStyles}>{`+${count - 1}`}</Box> : null}
      {isVideo ? <Icon as={BiPlayCircle} sx={videoIconStyles} /> : null}
    </Box>
  );
};

SimplePostCover.propTypes = {
  src: PropTypes.string,
  count: PropTypes.number,
  isPast: PropTypes.bool,
  isVideo: PropTypes.bool,
};

SimplePostCover.defaultProps = {
  src: null,
  count: 0,
  isPast: false,
  isVideo: false,
};

export default memo(SimplePostCover);
